import React, {FC, Fragment, useState} from 'react';
import {Link} from 'react-router-dom';

import {BetData, GenericProps} from 'utils/types';
import useBreakpointXL from 'hooks/useBreakpointXL';

import './styles.scss';
import arrow from 'assets/svg/bet_arrow.svg';

interface Props extends GenericProps {
  className?: string;
  collapsible?: boolean;
  betData: BetData;
}

const WidgetBet: FC<Props> = ({className, collapsible, betData: {provider, odds}}: Props) => {
  const [collapsed, setCollapsed] = useState(collapsible);
  const isBreakpointXL = useBreakpointXL();
  return null;
  /*
  return (
    <section className={`WidgetBet ${className}`}>
      {isBreakpointXL && <h3 className="WidgetBet__header">BET</h3>}
      {odds && (
        <div
          className={`WidgetBet__oddsWrapper ${
            collapsed ? 'WidgetBet__oddsWrapper--collapsed' : ''
          }`}
        >
          {odds.map(group => (
            <Fragment key={group.title}>
              <h6 className="WidgetBet__oddsHeader">{group.title}</h6>
              {group.values.map((value, i) => {
                let tileType;
                if (['result', 'handicap', 'overunder'].includes(group.type)) {
                  if (i === 0) tileType = 'home';
                  else if (i === group.values.length - 1) tileType = 'away';
                  else tileType = 'tie';
                }
                return (
                  <div
                    className={`WidgetBet__oddsTile ${
                      tileType ? `WidgetBet__oddsTile--${tileType}` : ''
                    }`}
                    key={`${group.type}-${group.title}-${value.label ?? '0'}-${value.value}`}
                  >
                    {'label' in value && (
                      <span className="WidgetBet__oddsLabel">{value.label}</span>
                    )}
                    <span className="WidgetBet__oddsValue">{value.value}</span>
                  </div>
                );
              })}
            </Fragment>
          ))}
        </div>
      )}
      {provider && (
        <div className="WidgetBet__provider">
          <span className="WidgetBet__providerLabel">POWERED BY</span>
          <Link
            className="WidgetBet__providerLogo"
            to={provider.clickUrl}
            target="_blank"
            rel="external noopener noreferrer"
          >
            <img
              src={isBreakpointXL ? provider.imageUrlDark : provider.imageUrlLight}
              alt={provider.name}
            />
          </Link>
        </div>
      )}
      {collapsible && (
        <div className="WidgetBet__expander">
          <button
            className="WidgetBet__expanderButton"
            type="button"
            onClick={() => setCollapsed(!collapsed)}
          >
            <img
              className={`WidgetBet__expanderArrow ${
                collapsed ? 'WidgetBet__expanderArrow--collapsed' : ''
              }`}
              src={arrow}
              alt="expand"
            />
          </button>
        </div>
      )}
    </section>
  );
  */
};

export default WidgetBet;
